import axios from "axios";

import { HttpQuery } from "@Types/http";
import { auth } from "@Firebase/firebase";
import { LenderTutorial } from "@Types/lender_tutorials";

export const getTutorials = (
  query?: HttpQuery
): (() => Promise<LenderTutorial[]>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_tutorial/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return response.data.result?.docs ?? [];
  };
};

export const getTutorial = (id: string): (() => Promise<LenderTutorial>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_tutorial/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
export const likeTutorial = (id: string): (() => Promise<LenderTutorial>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender/${id}`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};
